let login = {
    zhCN: "Chinese",
    title: '用户登录',
    backLogin:"返回登录",
    loginText: "登录",
    pwdLogin: '密码登录',
    scanLogin: '扫码登录',
    usernamePlaceholder: '邮箱',
    authenticationMethod: '请选择以下任一认证方式登录',
    authenticationMethodss: '请选择以下任一认证方式',
    otpPlaceholder: "请输入OTP动态口令或点击推送",
    fidoUaf: "您已选择飞天云信令(FIDO)认证，请点击登录按钮并打开飞天云信令APP校验人脸/指纹完成登录！",
    fidoU2f: "您已选择FIDO2认证方式，请点击登录按钮完成登录！",
    feiTianFastLogin:"您已选择飞天云信令FastLogin认证方式，请点击登录按钮完成登录！",
    forgetPwd: "忘记密码？",
    accountPwdLogin: "账号密码登录",
    tempLoginPlaceholder: "请输入临时认证口令",
    clickRefresh: "点击刷新",
    codeTitle: "使用飞天云信令扫码登录",
    qrCodeSuccess: "扫码成功",
    confirmLogin: "请在飞天云信令确认登录",
    otherMethods: "其他方式",
    usernameMsg: "请输入用户名/邮箱/手机号",
    onlyUsernameMsg: "请输入用户名",
    qrText: "当前二维码已过期",
    noEmptyPwd: "密码不能为空",
    qrLoseEfficacy: "当前二维码已失效",
    dynamicPassword: "请输入动态口令！",
    messageAuthenticationCode: "请输入短信验证码！",
    emailCode: "请输入邮箱验证码！",
    temporaryPwd: "请输入临时认证口令！",
    loginSuccess: "登录成功",
    authSuccess:"您的身份认证成功！",
    canClose:"现在您可以关闭这个浏览器标签。",
    clickDown:"点击下方的桌面软件进行操作！",
    binding: {
        title: "绑定",
        text: "用户绑定"
    },
    computationNum: {
        title: "请完成安全验证",
        result: "请输入结果",
        resultErr: "校验结果不能为空！"
    },
    editPwd: {
        title: "修改密码",
    },
    retrieveEmail: {
        title: "找回密码",
        emailMsg: "请输入正确的邮箱格式",
        back: "返回登录",
        goPhone: "通过手机号找回",
    },
    retrievePwd: {
        phone: "请输入手机号",
        goEmail: "通过邮箱找回",
        phoneErr: "手机号格式错误，请重新输入"
    },
    subAccount: {
        title: "应用账号选择",
       subtitle:'请选择应用账号进行单点登录',
        placeholder: "请选择应用账号",
        unuse:'该账号已停用，请联系您的企业管理员进行启用！'
    },
    jiantou: "使用飞天云信令FastLogin一键登录",
    maybe: "或者",
    fastLogin: "您已选择飞天云信令FastLogin认证方式，请点击登录按钮继续操作！",
    appLogin: "请打开飞天云信令APP扫码登录",
    idenAuth:"请进行身份认证",
    cloundBind:"云信令绑定",
    scanSucc:"扫码成功",
    sureConfirm:"确定",
    confirmL:"请在飞天云信令确认登录",
    loginOutTime:"登录超时，请重新登录！",
    notSupportWeb:"这个浏览嚣不支持Web认证！",
    supportSecurity:"Web认证仅支持安全连接",
    push:"推送",
    bind:"绑定",
}

export default login
